import { z } from "zod";

/**
 * The overnight-update form's validation schema (V2-E8.1, HAN-68). Mirrors
 * `overnightUpdateInputSchema` in `@handoverpro/shared` — `whatHappened` and
 * `whatWasDone` are required and non-empty after trim; `dayTeamNotes` is
 * optional — plus a client-only length cap on each textarea so the two can't
 * drift on the rules that matter (the cap is a UI affordance the API doesn't
 * enforce, same as the patient form).
 */
const OVERNIGHT_FIELD_MAX = 2000;

const cappedRequiredText = z
  .string()
  .trim()
  .min(1, "This field is required")
  .max(OVERNIGHT_FIELD_MAX, `Must be at most ${OVERNIGHT_FIELD_MAX} characters`);

export const overnightUpdateFormSchema = z.object({
  whatHappened: cappedRequiredText,
  whatWasDone: cappedRequiredText,
  // Optional emphasis for the day team; "" means "no notes".
  dayTeamNotes: z
    .string()
    .trim()
    .max(OVERNIGHT_FIELD_MAX, `Must be at most ${OVERNIGHT_FIELD_MAX} characters`),
});

export type OvernightUpdateFormValues = z.infer<typeof overnightUpdateFormSchema>;

/** Defaults for an empty (no update saved yet) form. */
export const EMPTY_OVERNIGHT_FORM: OvernightUpdateFormValues = {
  whatHappened: "",
  whatWasDone: "",
  dayTeamNotes: "",
};
